import { z } from 'zod';

import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const EvaluatablePluginWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.EvaluatablePlugin).extend({
  pluginId: z.string()
});

export type EvaluatablePluginWidgetStaticSchemaType = z.infer<typeof EvaluatablePluginWidgetStaticSchema>;
